module.exports = __webpack_public_path__ + "video-thumbnail-widget-76666babdf210b8d22990f77aeb972e7.jpg";